
export const navigationRightSelector = "#navigation__right";
export const navigationLeftSelector = "#navigation__left";
